<template>
  <v-text-field
    v-model="forgejoSite"
    :color="valid ? 'green' : 'red'"
    :hint="valid ? 'valid Forgejo site' : 'Not a valid forgejo site'"
    label="Forgejo site e.g. codeberg.org"
    placeholder="forgejo site url"
    required
    type="text"
    @keyup="change"
  />
</template>
<script setup lang="ts">
import type { Ref } from "vue";
import { ref } from "vue";

const emit = defineEmits<(e: "change", url: string) => void>();

const model = defineModel({ type: String });

const forgejoSite: Ref<string | undefined> = ref(undefined);
const checkedValue = ref("");
const valid = ref(false);

async function change() {
  let url = forgejoSite.value ?? "";
  if (url === checkedValue.value) {
    return;
  }
  checkedValue.value = url;
  url = url.replace(/^https?:\/?\/?/i, "");
  url = url.replace(/\/.*$/i, "");
  if (!url.includes(".")) {
    valid.value = false;
    return;
  }
  url = "https://" + url;
  const apiUrl = url + "/api/v1/version";
  try {
    valid.value = false;
    const r = await fetch(apiUrl);
    valid.value = r.ok;
    if (r.ok) {
      valid.value = true;
      model.value = url;
      emit("change", url);
    }
  } catch (error) {
    console.error(error);
  }
}
</script>
